{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Presegli ste omejitev pogovorov. Paket Hacker dovoljuje samo 500 pogovorov.",
      "INBOXES": "Presegli ste omejitev nabiralnikov. Paket Hacker podpira samo spletni klepet v živo. Dodatni nabiralniki, kot so e-pošta, WhatsApp itd., zahtevajo plačljiv paket.",
      "AGENTS": "Presegli ste omejitev agentov. Paket Hacker dovoljuje samo 2 agenta.",
      "NON_ADMIN": "Za nadgradnjo paketa in nadaljnjo uporabo vseh funkcij se obrnite na skrbnika."
    },
    "TITLE": "Account settings",
    "SUBMIT": "Update settings",
    "BACK": "Back",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Could not update settings, try again!",
      "SUCCESS": "Successfully updated account settings"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Izbriši svoj račun",
      "NOTE": "Ko izbrišete svoj račun, bodo izbrisani vsi vaši podatki.",
      "BUTTON_TEXT": "Izbriši svoj račun",
      "CONFIRM": {
        "TITLE": "Izbriši račun",
        "MESSAGE": "Izbris računa je nepovraten. Spodaj vnesite ime svojega računa, da potrdite trajni izbris.",
        "BUTTON_TEXT": "Izbriši",
        "DISMISS": "Prekliči",
        "PLACE_HOLDER": "Za potrditev vnesite {accountName}"
      },
      "SUCCESS": "Račun je označen za izbris",
      "FAILURE": "Računa ni bilo mogoče izbrisati, poskusite znova!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Ta račun je predviden za izbris dne {deletionDate}. To je zahteval skrbnik. Izbris lahko prekličete pred tem datumom.",
        "MESSAGE_INACTIVITY": "Ta račun je predviden za izbris dne {deletionDate} zaradi nedejavnosti računa. Izbris lahko prekličete pred tem datumom.",
        "CLEAR_BUTTON": "Prekliči predvideni izbris"
      }
    },
    "FORM": {
      "ERROR": "Please fix form errors",
      "GENERAL_SECTION": {
        "TITLE": "General settings",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Account name",
        "PLACEHOLDER": "Your account name",
        "ERROR": "Please enter a valid account name"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Your account name",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "The domain where you will receive the emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support Email",
        "PLACEHOLDER": "Your company's support email",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Number of days after a ticket should auto resolve if there is no activity",
        "NOTE": "Število ur nedejavnosti, po katerih se vsak odprt pogovor samodejno reši.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Število dni, po katerih se prazen pogovor samodejno reši, če ni dejavnosti",
        "PLACEHOLDER": "nikoli",
        "ERROR": "Vnesite veljavno trajanje za samodejno reševanje praznih pogovorov (najmanj 1 dan in največ 999 dni)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Conversation continuity with emails is enabled for your account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "You can receive emails in your custom domain now."
      },
      "PHONE": {
        "TITLE": "Nastavitve PBX",
        "NOTE": "Nastavite povezavo s svojim PBX za telefonske klice",
        "SIP_HOST": {
          "LABEL": "Domena SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Način klicanja",
          "MODES": {
            "direct": "Neposredno – klic se izvede takoj ob kliku na telefonsko povezavo",
            "indirect": "Posredno – telefonska številka se pripravi v vnosnem polju telefonskega widgeta"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Dostop do posnetkov klicev",
          "MODES": {
            "admin_only": "Samo skrbniki",
            "admin_and_assigned_agent": "Skrbniki in dodeljeni agent",
            "inbox_members": "Vsi agenti z dostopom do nabiralnika"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Nastavitve e-pošte",
        "NOTE": "Spremeni delovanje e-poštnih nabiralnikov"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Način prikaza časovnega žiga pogovora",
        "MODES": {
          "both": "Ustvarjeno in zadnja dejavnost",
          "last_activity_only": "Samo zadnja dejavnost",
          "last_customer_message": "Zadnje sporočilo stranke"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokiraj domene z nizkim ugledom"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Vključi izvirno sporočilo v odgovor na e-pošto"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Samodejno reši nov pogovor"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Samodejno premakni nov e-poštni pogovor v predal robota, ki je obdelal naročila stika"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Razširjene oznake – omogoči daljša imena oznak z večjim pojavnim vmesnikom"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent – samodejno dodeli pogovor agentu, ki je ustvaril zadnji odgovor"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Način potisnih obvestil",
        "MODES": {
          "all_inboxes": "Vsi nabiralniki – pošlji obvestila za vse vrste kanalov",
          "chat_only": "Samo klepet – pošlji obvestila samo za kanale, ki niso e-pošta"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Dovoli preklop podpisa pri poslanih sporočilih"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Prikaži stanje klepeta agenta na wallboardu"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Prikaži polna imena prilog brez skrajšanja"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Prijava z geslom",
        "MODES": {
          "allowed_for_all": "Dovoljeno za vse uporabnike",
          "allowed_for_agents_only": "Dovoljeno samo za agente (skrbniki morajo uporabljati OAuth)",
          "password_login_disabled": "Onemogočeno – samo OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Na voljo je nova različica. Znova naložite stran za najnovejše posodobitve.",
    "RELOAD_NOW": "Posodobi zdaj",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Vaše plačilo je v teku. Posodobite podatke za plačilo, da boste lahko še naprej uporabljali kontaktni center",
    "LIMITS_UPGRADE": "Vaš račun je presegel omejitve uporabe. Nadgradite svoj paket, da boste lahko še naprej uporabljali kontaktni center",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Press enter to select",
      "ENTER_TO_REMOVE": "Press enter to remove",
      "NO_OPTIONS": "Seznam je prazen",
      "NO_RESULT": "Ni rezultatov",
      "SELECT_ONE": "Select one",
      "SELECT": "Izberi"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "No Notifications",
      "TABLE_HEADER": [
        "Name",
        "Phone Number",
        "Conversations",
        "Last Contacted"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "New conversation",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "New Message",
      "participating_conversation_new_message": "New Message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Povezava je prekinjena",
      "DESCRIPTION": "Strežnika ni bilo mogoče doseči. Preverite povezavo in poskusite znova.",
      "RETRY": "Poskusi znova"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Reports",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Zaženi makro",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Settings",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Zaženi makro",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click here"
  }
}
